export default {
  'fr-FR': {
    yes: 'oui',
    no: 'non',
    emptyPatientList: 'aucun patient',
    patientList: 'patients',
    addPatient: 'inclure un patient',
    loading: 'chargement',
    submit: 'valider',
    save: 'enregistrer',
    previous: 'précédent',
    next: 'suivant',
    cancel: 'annuler',
    value: 'valeur',
    morning: 'Matin',
    midday: 'Midi',
    evening: 'Soir',
    daysPerWeek: 'Nombre de jours par semaine',
    duration: 'durée',
    when: 'Quand ? ',
    minutes: 'Minutes',
    hours: 'Heures',
    beforeMeals: 'Avant les repas',
    afterMeals: 'Après les repas',
    duringMeals: 'Pendant les repas',
    days: 'Jours',
    months: 'Mois',
    years: 'Années',
    HH: 'très haut',
    H: 'haut',
    N: 'normal',
    L: 'bas',
    reviewHistory: 'Historique des revues',
    LL: 'très bas',
    '8867-4': 'pouls',
    '29463-7': 'poids',
    '9279-1': 'Fréquence respiratoire',
    '27353-2': 'glycémie',
    '8480-6': 'tension systolique',
    '8462-4': 'tension diastolique',
    '38483-4': 'creatinine',
    '59826-8': 'creatinine',
    '33914-3': 'clairance mdrd',
    '62238-1': 'clairance ckg',
    '35591-7': 'clairance selon Cockroft',
    '2947-0': 'sodium',
    '2824-1': 'potassium',
    '2069-3': 'chlore',
    '26453-1': 'erythrocytes',
    '30350-3': 'hémoglobine',
    '20570-8': 'hématocrite',
    '30428-7': 'colume Globulaire Moyen',
    '28540-3': 'CCMH',
    '28539-5': 'TCMH',
    '26464-8': 'Leucocytes',
    '26499-4': 'polynucléaires neutrophiles',
    '26449-9': 'polynucléaires éosinophiles',
    '26444-0': 'polynucléaires basophiles',
    '26474-7': 'lymphocytes',
    '26484-6': 'monocytes',
    '26515-7': 'plaquettes',
    '14196-0': 'réticulocytes',
    '1916-6': 'ASAT',
    '76625-3': 'ALAT',
    '2324-2': 'gamma GT',
    '1783-0': 'phosphatases alcalines',
    '54363-7': 'bilirubine totale',
    '2888-6': 'proteinurie',
    consentGiven: 'consentement recueilli',
    type1Diabetes: 'diabète de type 1',
    type2Diabetes1Injection:
      "diabète de type 2 sous insulinothérapie à hauteur d'une injection",
    type2DiabetesOtherSchemas:
      'diabète de type 2 sous autres schémas insuliniques',
    heartFailure: 'insuffisance cardiaque',
    eligiblePatients: 'patients éligibles',
    eligiblePatient: 'patient éligible',
    nonEligiblePatients: 'patients non éligibles',
    majorityCriterion: 'âgé de 18 ans ou plus',
    type1DiabetesCriterion:
      'présentant un diabète de type 1 (DT1) déséquilibrés, avec une HbA1c supérieure ou égale à 8 % lors de deux mesures réalisées dans un intervalle de temps de 6 mois malgré une mise sous insuline de plus de 6 mois.',
    type2DiabetesCriterion:
      'présentant un diabète de type 2 (DT2) sous insuline diagnostiqué depuis plus de 12 mois chroniquement déséquilibrés, avec une HbA1c supérieure ou égale à 9 % lors de deux mesures réalisées dans un intervalle de temps de 6 mois malgré une mise sous insuline de plus de 6 mois.',
    heartFailure1Criterion:
      ' Hospitalisation au cours des 30 derniers jours pour une poussée d’insuffisance cardiaque chronique (diagnostic principal, au regard du compte-rendu ou du codage CIM 10- |500|501|502|509)',
    heartFailure2Criterion:
      ' Hospitalisation au moins une fois au cours des 12 derniers mois pour une poussée d’insuffisance cardiaque chronique (diagnostic principal, au regard du compte-rendu ou du codage CIM 10- |500/|501/|502/|509) et actuellement en classe de NYHA 2 ou plus avec un taux de peptides natriurétiques élevé (BNP > 100 pg/ml ou NT pro BNP> 1000 pg/ml).',
    kidneyFailureCriterion:
      'Patients transplantés rénaux ayant été greffés il y’a plus de 6 mois',
    abilityCriterion:
      "impossibilité physique ou psychique d'utiliser tous les composantsdu projet de télésurveillance selon le jugement du médecin désirantinclure le patient dans le projet de télésurveillance",
    dialysisCriterion: 'dialyse chronique',
    liverFailureCriterion: 'insuffisance hépatique sévère',
    pathologyCriterion:
      "toute pathologie associée existante au jour de l'inclusion,impliquant, selon le médecin incluant le patient une espérance de vie inférieure à 12 mois en dehors {disease, select, diabetes {du diabète} heartFailure {de l'insufficance cardiaque}}",
    companionCriterion:
      "refus du patient d'avoir un accompagnement thérapeutique",
    homeCriterion: 'absence de lieu de séjour fixe.',
    kidneyFailure: 'Insuffisance rénale',
    nonEligibilityCriterion1: 'Patients au stade IV de l’évolution de l’insuffisance rénale chronique n’étant pas encore dialysés',
    nonEligibilityCriterion2: 'Les patients dialysés en centre de dialyse de façon habituelle',
    nonEligibilityCriterion3: 'Les patients dialysés à domicile quel que soit le mode de dialyse',
    alerts: 'dernières alertes',
    history: 'historique',
    weeklyReport: 'rapport hebdomadaire',
    open: 'ouvrir'
  }
}



// WEBPACK FOOTER //
// ./src/messages.js